import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'colorMonth'
})
export class ColorMonthPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null): SafeHtml {
    if (!value) {
      return '';
    }
    const words = value.split(' ');
    const monthIndex = words.findIndex(word => /[a-z]{3,}/i.test(word));
    words[monthIndex] = `<span class="month">${words[monthIndex]}</span>`;
    return this.sanitizer.bypassSecurityTrustHtml(words.join(' '));
  }

}
